import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    
    const processAuth = async () => {
      try {
        const hash = window.location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);

        if (!sessionIdMatch) {
          if (isMounted) navigate('/', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('Processing session_id:', sessionId.substring(0, 20) + '...');
        
        const response = await api.post('/auth/session', {
          session_id: sessionId
        });
        
        console.log('Auth successful, user:', response.data.user);
        
        // Store token in localStorage for persistence
        localStorage.setItem('session_token', response.data.session_token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        
        if (isMounted) {
          navigate('/dashboard', { replace: true });
        }
      } catch (error) {
        console.error('Auth error:', error.response?.data || error.message);
        const errorMsg = error.response?.data?.detail?.error_description || error.response?.data?.detail || 'Authentication failed';
        alert(`Login failed: ${errorMsg}\n\nPlease try again.`);
        
        if (isMounted) {
          navigate('/', { replace: true });
        }
      }
    };

    processAuth();
    
    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center">
        <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto mb-4" />
        <p className="text-muted-foreground">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
